export default __webpack_public_path__ + "static/media/g2.9fd1d43a.png";